
import { Component, Vue } from "vue-property-decorator";
import t from "@common/src/i18n/t";
import { namespace } from "vuex-class";
import SettlementPrint from "./components/settlement-print.vue";
import InvoiceDropdown from "./components/make-invoice-dropdown.vue";
const service = namespace("service");
const store = namespace("store");
const finance = namespace("finance");
const common_app = namespace("common_app");
@Component({
  components: {
    SettlementPrint,
    InvoiceDropdown
  }
})
export default class SettlementSuccess extends Vue {
  @service.Action getOrderDetail;
  @store.State storeData;
  @finance.Action getReceiptDetail;
  @common_app.State country;
  showPreviewPrint: boolean = false;
  detailDataPrint: any = {
    orderStatus: "9",
    photoList: [],
    allOrderDetail: { service: [], parts: [], additional: [], receiptData: {} }
  };
  detailData: any = {
    orderStatus: "9",
    photoList: [],
    action: {
      printArray: []
    }
  };
  settlementPrintObj: any = {
    id: "printMer1",
    popTitle: t("service.final-statement"),
    extraCss: "",
    extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
  };
  get breadData() {
    // 判断来源是服务还是挂账
    return this.onAccountTo
      ? [
          {
            name: t("finance.payment-management"),
            path: "/finance/on-account-manage"
          },
          { name: t("service.collecting-results") }
        ]
      : [
          {
            name: t("test.service-management"),
            path: "/service/index"
          },
          { name: t("service.collecting-results") }
        ];
  }
  get onAccountTo() {
    return this.$route.path === "/service/settlement-success-credit" ? true : false;
  }
  get orderId() {
    return this.$route.query.orderId;
  }
  get onAccountOrderId() {
    return this.$route.params.orderId;
  }
  get isGetQualification() {
    return this.$route.query.canLotteryLength === "0" ? false : true;
  }
  created() {
    this.init();
  }
  init() {
    this.getOrderDetail({
      orderNo: this.orderId
      // orderNo: this.onAccountOrderId
    }).then(data => {
      console.log("[ data ]", data);
      this.detailData = data.data;
      this.detailDataPrint = data.data;
    });
  }
  handleInvoice() {
    this.$router.push(`/service/make-invoice/${this.onAccountOrderId || this.orderId}`);
  }
  handleCopyMenuClick() {
    this.detailData.storeData = this.storeData;
    console.log("[  ]", this.detailData.receiptNo);
    if (!this.detailData.receiptNo) {
      return this.$message.error(t("other.tamll-order-print-tips") as string);
    }
    this.queryAllOrderByReceipt().then(() => {
      this.showPreviewPrint = true;
    });
  }
  queryAllOrderByReceipt() {
    const service = [];
    const parts = [];
    const additional = [];
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    return this.getReceiptDetail({
      receiptNo: this.detailDataPrint.receiptNo,
      pageSize: 999,
      pageNum: 1
    }).then(
      async receiptData => {
        const orderList = receiptData.data.orderList || [];
        for (let i = 0; i < orderList.length; i++) {
          await this.getOrderDetail({
            orderNo: orderList[i].orderNo
          }).then(data => {
            if (data.data.serviceDetail && data.data.serviceDetail.length > 0) {
              service.push(...data.data.serviceDetail);
            }
            if (data.data.partsDetail && data.data.partsDetail.length > 0) {
              parts.push(...data.data.partsDetail);
            }
            if (data.data.additionalFees) {
              additional.push({
                additionalFees: data.data.additionalFees,
                additionalFeesRemark: data.data.additionalFeesRemark
              });
            }
          });
        }
        loading.close();
        this.detailDataPrint.allOrderDetail = { service, parts, additional, receiptData: receiptData.data };
        console.log(service, parts, additional);
      },
      () => {
        loading.close();
      }
    );
  }
}
